/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, { FC, MouseEventHandler, useCallback, useMemo } from 'react';
import { DateRangePicker } from '@material-ui/pickers';
import parseISO from 'date-fns/parseISO';
import { TextField } from '@material-ui/core';
import { isValid } from 'date-fns';
import { ParsableDate } from '@material-ui/pickers/src/constants/prop-types';

import { IEntityFieldProps } from 'icerockdev-admin-toolkit';

type IProps = IEntityFieldProps & {};

const EntityFieldDateRange: FC<IProps> = ({
                                              value,
                                              handler,
                                              label,
                                              isFiltering,
                                          }) => {
    const onChange = useCallback(
        (value) => {
            if (!value || !handler) return;

            const start = parseDateValue(value[0]);
            const end = parseDateValue(value[1]);

            handler([start, end].join(','));
        },
        [value, handler]
    );

    const parsed = useMemo<[ParsableDate, ParsableDate]>(() => {
        if (!value) return [null, null];

        const split = value && value.split(',');

        if (!split || split.length !== 2) return [null, null];

        const start = (isValid(new Date(split[0])) && split[0]) || null
        const end = (isValid(new Date(split[1])) && split[1]) || null

        return [start, end]
    }, [value]);

    if (!isFiltering) return null;

    return (
        <div className="datepicker datepicker_range">
            <DateRangePicker
                renderInput={(startProps, endProps) => (
                    <>
                        <TextField
                            {...startProps}
                            variant="outlined"
                            helperText={label}
                            label=""
                        />
                        <TextField
                            {...endProps}
                            variant="outlined"
                            helperText=""
                            label=""
                        />
                    </>
                )}
                value={parsed}
                onChange={onChange}
            />
        </div>
    );
};

function parseDateValue(value) {
    if(!value) return '';

    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return year + "-" + month + "-" + day;
}

export { EntityFieldDateRange };